import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Button,
    Typography,
    Divider
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { pricingPlanCardItems } from './pricing-constants';
import PlanCardSkeleton from 'ui-component/cards/Skeleton/PlanCardSkeleton';
// import CheckedRadioCircleBlue from 'Components/Icons/CheckRadioCircleBlue';
// import RadioCircleBlue from 'Components/Icons/RadioCirlceBlue';
import PricingDecor from 'assets/images/dashboard/pricing/pricing-decor.png';
import { PLAN_TYPE } from 'helper/checkPlan.helper';
import RecommendedTag from './RecommendedTag';
import { Box } from '@mui/system';
import PricingCardShareHolderWithFAQ from './PricingCardShareHolderWithFAQ';
const PricingCardItem = ({ planList, setSelectedPlans, onHandleClickPlan, loading, selectedTier }) => {
    return (
        <Grid sx={{ mt: 2 }} container justifyContent="center" alignContent={'flex-start'} spacing={{ xs: 2, lg: 5 }}>
            <div className="decor-background">
                <img src={PricingDecor} alt="pricing-decor" />
            </div>

            {planList.length ? (
                pricingPlanCardItems.map((planCardItem) => {
                    const planItem = planList.find((plan) => plan?.name === planCardItem?.heading);

                    return (
                        <>
                            <Grid sx={{ position: 'relative' }} item key={planCardItem.id}>
                                {planCardItem?.type !== 'shareholder' ? (
                                    <Card className={`card-wrapper ${PLAN_TYPE.Premium == planCardItem.heading ? 'premium' : ''}`}>
                                        {PLAN_TYPE.Premium === planCardItem?.heading && <RecommendedTag />}
                                        <CardHeader
                                            title={
                                                <>
                                                    <h2 className="small-heading">{planCardItem.haedingToShow}</h2>
                                                </>
                                            }
                                            style={{ padding: '0' }}
                                        />
                                        <CardContent style={{ padding: '0' }}>
                                            <Typography variant="p" component={'p'} className="tier-description">
                                                {planCardItem.subTitle}
                                            </Typography>
                                        </CardContent>

                                        <CardContent style={{ padding: '0' }}>
                                            <Typography
                                                variant="h1"
                                                component="span"
                                                className="title-heading price-heading text-dark-blue"
                                            >
                                                {selectedTier === 'infinite' ? '' : planCardItem.currency}
                                            </Typography>
                                            <Typography
                                                variant="h1"
                                                component="span"
                                                className="title-heading price-heading text-dark-blue"
                                            >
                                                {planCardItem.heading === PLAN_TYPE.Freemium
                                                    ? planCardItem.amount
                                                    : planCardItem.amount[selectedTier]}
                                            </Typography>
                                            {planCardItem?.recurring && selectedTier !== 'infinite' && (
                                                <Typography
                                                    sx={{ ml: 4 }}
                                                    variant="p"
                                                    component="span"
                                                    className="tier-description"
                                                    style={{ marginLeft: '16px' }}
                                                >
                                                    {selectedTier === 'infinite' ? '' : '/'} {planCardItem.recurring}
                                                </Typography>
                                            )}
                                        </CardContent>

                                        <Typography variant="p" component="p" className="tier-sub-description fw-400">
                                            {planCardItem.heading === PLAN_TYPE.Freemium
                                                ? planCardItem?.subDescription
                                                : planCardItem.subDescription[selectedTier]}

                                            {planCardItem?.recurringYear && selectedTier !== 'infinite' && (
                                                <Typography
                                                    // sx={{ ml: 4 }}
                                                    variant="p"
                                                    component="span"
                                                    className="tier-description"
                                                    style={{ marginLeft: '3px' }}
                                                >
                                                    /{planCardItem?.recurringYear}
                                                </Typography>
                                            )}
                                        </Typography>
                                        {/* <Box sx={{ paddingTop: PLAN_TYPE.Premium == planCardItem.heading ? 1 : 4 }}> */}
                                        <Box>
                                            {planCardItem.heading === PLAN_TYPE.Freemium ||
                                            (planCardItem.heading == PLAN_TYPE.Premium && selectedTier !== 'infinite') ? (
                                                <Button
                                                    className="pricing-button"
                                                    disabled={loading}
                                                    onClick={() => onHandleClickPlan(planItem.default_price, planItem.name)}
                                                >
                                                    Select
                                                </Button>
                                            ) : null}
                                            {planCardItem.heading !== PLAN_TYPE.Freemium &&
                                            planCardItem.heading == PLAN_TYPE.Premium &&
                                            selectedTier === 'infinite' ? (
                                                <Button
                                                    className="pricing-button"
                                                    disabled={loading}
                                                    onClick={() => window.open('https://www.diolog.com.au/contact', '_blank')}
                                                >
                                                    Contact Sales
                                                </Button>
                                            ) : null}
                                        </Box>
                                        <CardContent style={{ padding: '32px 0' }}>
                                            <Divider variant="fullWidth" />
                                        </CardContent>
                                        <CardContent style={{ padding: '0' }}>
                                            <Typography variant="p" component="p" className="text-after-button">
                                                {planCardItem.textAfterButton}
                                            </Typography>
                                        </CardContent>

                                        <List className="feature-lists">
                                            {planCardItem.listItem.map((item) => {
                                                return (
                                                    <ListItem key={item.id}>
                                                        <ListItemIcon>
                                                            <CheckIcon sx={{ fill: '#fc7013' }} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={
                                                                <Typography variant="p" className="tier-description">
                                                                    {item.text}
                                                                </Typography>
                                                            }
                                                        />
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                        {/* <div className={`${planCardItem.heading === PLAN_TYPE.Premium ? 'footer-decor' : 'footer-decor-2'}`}>
                                        <img src={planCardItem.footerIcon} alt="footer-icon" />
                                    </div> */}
                                        {/* </CardContent> */}
                                    </Card>
                                ) : (
                                    <PricingCardShareHolderWithFAQ data={planCardItem} onHandleClickPlan={setSelectedPlans} />
                                )}
                            </Grid>
                        </>
                    );
                })
            ) : (
                <PlanCardSkeleton />
            )}
        </Grid>
    );
};
export default PricingCardItem;
